<template>
  <table class="table table-hover" v-cloak>
    <div v-for="(permission, index) in permissions" :key="index">
      <thead>
        <tr>
          <th scope="col" style="width:50%">{{permission.key}}</th>
          <th scope="col">
            {{permission.key === 'User Setting' ? 'No Access' : 'No Access'}}</th>
          <th scope="col">
            {{permission.key === 'User Setting' ? 'Read Only' : 'Read Only'}}</th>
          <th scope="col" >
            {{permission.key === 'User Setting' ? 'Manage' : 'Manage' }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(test, index) in permission.value" :key="index">
          <td>{{ test.name }}</td>
          <td><b-form-radio v-model="test.value"
          value='no access' :disabled="permissionDisable(test.name, 'no access')">
          </b-form-radio></td>
          <td><b-form-radio v-model="test.value"
          value='read only' :disabled="permissionDisable(test.name, 'read only')">
          </b-form-radio></td>
          <td><b-form-radio v-model="test.value"
          value='manage' :disabled="permissionDisable(test.name, 'manage')">
          </b-form-radio></td>
        </tr>
      </tbody>
    </div>
<!--
    <thead>
      <tr>
        <th scope="col">User Settings</th>
        <th scope="col">No Access</th>
        <th scope="col">Read Only</th>
        <th scope="col">Manage</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(permission, index) in permissions" :key="index">
        <td>{{ permission.name }}</td>
        <td><b-form-radio v-model="permission.value" name='no access'
        value='no access' :disabled="permissionDisable(permission.name, 'no access')">
        </b-form-radio></td>
        <td><b-form-radio v-model="permission.value" name='read only'
        value='read only' :disabled="permissionDisable(permission.name, 'read only')">
        </b-form-radio></td>
        <td><b-form-radio v-model="permission.value" name='manage'
        value='manage' :disabled="permissionDisable(permission.name, 'manage')">
        </b-form-radio></td>
      </tr>
    </tbody>
    <head>
      <ttr>
        <th scope="col">User</th>
        <th scope="col">No Access</th>
        <th scope="col">Read Only</th>
        <th scope="col">Manage</th>
      </tr>
    </thead> -->
  </table>
</template>

<script>
export default {
  name: 'PermissionAdmin',
  props: ['permissions'],
  data() {
    return {
      disabledPermission: {
        'Admin Account': {
          'no access': true,
          'read only': true,
          manage: false,
        },
        'User Profile': {
          'no access': true,
          'read only': true,
          manage: false,
        },
        'Set Rates': {
          'no access': true,
          'read only': true,
          manage: false,
        },
        'Booking Details': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Booking Charges': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Payment Activity': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Shipment Record-Pickup': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Shipment Record-Warehouse': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Shipment Record-ToLoad': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Shipment Record-ToOffload': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Shipment Record-Delivering': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Shipment Record-Delivered': {
          'no access': true,
          'read only': false,
          manage: true,
        },
        'Shipment Record-Unpaid': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Shipment Record-Flagged': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Manifest Details': {
          'no access': true,
          'read only': false,
          manage: false,
        },
        'Analytics-Dashboard': {
          'no access': false,
          'read only': false,
          manage: true,
        },
        'Analytics-Mangement': {
          'no access': false,
          'read only': false,
          manage: true,
        },
        'Customer BOL': {
          'no access': false,
          'read only': false,
          manage: true,
        },
        'Dock Receipt': {
          'no access': false,
          'read only': false,
          manage: true,
        },
        'Master Bol-Manifest': {
          'no access': false,
          'read only': false,
          manage: true,
        },
        'Airway Bol': {
          'no access': true,
          'read only': true,
          manage: true,
        },
      },
    };
  },
  methods: {
    permissionDisable(name, toggle) {
      return this.disabledPermission[name][toggle];
    },
  },
  mounted() {
    this.initFormlessFloatingLabels();
  },
};
</script>

<style scoped>

</style>
